import { StoreType } from '@tock/shared/utils/connect';
import { createSelector } from 'reselect';

export const walkinWaitlistSelector = (state: StoreType) => state.walkinWaitlist;
const activeBusinessSelector = (state: StoreType) => state.app.config?.business;

export const onBusinessWalkinWaitlistSelector = createSelector(
  walkinWaitlistSelector,
  activeBusinessSelector,
  (walkinWaitlist, business) => {
    if (business?.id && walkinWaitlist.entries[business?.id]) {
      return {
        ...walkinWaitlist.entries[business.id],
      };
    } else {
      return null;
    }
  }
);
